// Curated icon palette for the folders/albums. Kept small and tasteful, to match
// the "Conto Dourado" tone.

export const DEFAULT_ICON = "📁";

export const ALBUM_ICONS: string[] = [
  "📁",
  "✈️",
  "🏖️",
  "🏔️",
  "🌆",
  "💛",
  "🌸",
  "🎂",
  "🎉",
  "🥂",
  "🍝",
  "☕",
  "🎄",
  "🎁",
  "📸",
  "🌅",
  "🏡",
  "🐾",
  "⭐",
  "💍",
];

/** Coerces to a valid icon (from the palette); falls back to the default. */
export function validIcon(icon: string): string {
  return ALBUM_ICONS.includes(icon) ? icon : DEFAULT_ICON;
}
